(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.OpenApp = {}));
}(this, (function (exports) { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var ua = navigator.userAgent || ''; // 版本号比较
  var isAndroid = /android/i.test(ua);
  var isIos = /iphone|ipod/i.test(ua);
  var isHuawei = /huawei/i.test(ua);
  var isIpad = navigator.userAgent.match(/(iPad)/) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  var isWechat = /micromessenger\/([\d.]+)/i.test(ua);
  var isWeibo = /(weibo).*weibo__([\d.]+)/i.test(ua);
  var isBaidu = /(baiduboxapp)\/([\d.]+)/i.test(ua);
  var isQQ = /qq\/([\d.]+)/i.test(ua);
  var isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua) || /covc\/\d{6}/i.test(ua);
  var isDingTalk = /(dingtalk)\/([\d.]+)/i.test(ua);
  var isQzone = /qzone\/.*_qz_([\d.]+)/i.test(ua); // 安卓 chrome 浏览器，包含 原生chrome浏览器、三星自带浏览器、360浏览器以及早期国内厂商自带浏览器

  var isOriginalChrome = /chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(ua) && isAndroid && ua.indexOf('Version') < 0;

  // 根据 param 生成 queryString
  function generateQS(param) {
    var qs = param !== undefined && param !== null ? Object.keys(param).filter(function (key) {
      return param[key] !== undefined && param[key] !== null;
    }).map(function (key) {
      return "".concat(key, "=").concat(encodeURIComponent(param[key]));
    }).join('&') : '';
    return qs ? "?".concat(qs) : '';
  } // 生成基本的 url scheme

  function buildScheme(config, options) {
    var path = config.path,
        param = config.param;
    var scheme = options.scheme,
        customBuildScheme = options.buildScheme;

    if (typeof customBuildScheme !== 'undefined') {
      return customBuildScheme(config, options);
    }

    var host = scheme.host,
        port = scheme.port,
        protocol = scheme.protocol,
        sPath = scheme.path;
    var portPart = port ? ":".concat(port) : '';
    var hostPort = host ? "".concat(host).concat(portPart, "/") : '';
    var qs = generateQS(param);
    return "".concat(protocol, "://").concat(hostPort).concat(sPath).concat(path).concat(qs);
  } // 生成业务需要的 url scheme（区分是否是外链）

  function generateScheme(config, options) {
    var outChain = options.outChain;
    var uri = buildScheme(config, options);

    if (typeof outChain !== 'undefined' && outChain) {
      var protocol = outChain.protocol,
          path = outChain.path,
          key = outChain.key;
      uri = "".concat(protocol, "://").concat(path, "?").concat(key, "=").concat(encodeURIComponent(uri));
    }

    return uri;
  } // 生成 android intent

  function generateIntent(config, options) {
    var outChain = options.outChain;
    var intent = options.intent,
        fallback = options.fallback;
    if (typeof intent === 'undefined') return '';
    var keys = Object.keys(intent);
    var intentParam = keys.map(function (key) {
      return "".concat(key, "=").concat(intent[key], ";");
    }).join('');
    var intentTail = "#Intent;".concat(intentParam, "S.browser_fallback_url=").concat(encodeURIComponent(fallback), ";end;");
    var urlPath = buildScheme(config, options);

    if (typeof outChain !== 'undefined' && outChain) {
      var path = outChain.path,
          key = outChain.key;
      return "intent://".concat(path, "?").concat(key, "=").concat(encodeURIComponent(urlPath)).concat(intentTail);
    }

    urlPath = urlPath.slice(urlPath.indexOf('//') + 2);
    return "intent://".concat(urlPath).concat(intentTail);
  } // 生成 universalLink

  function generateUniversalLink(config, options) {
    var universal = options.universal;

    if (typeof universal === 'undefined') {
      return '';
    }

    var host = universal.host,
        pathKey = universal.pathKey,
        uPath = universal.path;
    var path = config.path,
        param = config.param;
    var qs = generateQS(param);
    var newUniversalLink = "https://".concat(host).concat(uPath).concat(path).concat(qs);
    var oldUniversalLink = "https://".concat(host, "?").concat(pathKey, "=").concat(path).concat(qs.replace('?', '&'));
    return pathKey ? oldUniversalLink : newUniversalLink;
  } // 生成 应用宝链接

  function generateYingYongBao(config, options) {
    var url = generateScheme(config, options); // 支持 AppLink

    return "".concat(options.yingyongbao, "&android_schema=").concat(encodeURIComponent(url));
  } // 生成微信tag

  function generateWxTag(config, options) {
    var id = config.id,
        _config$height = config.height,
        height = _config$height === void 0 ? 40 : _config$height;
    var wxAppid = options.wxAppid;
    return "<wx-open-launch-app id=\"launch_".concat(id, "\" appid=\"").concat(wxAppid, "\" extinfo=\"").concat(buildScheme(config, options), "\" style=\"position:absolute;top:0;left:0;right:0;bottom:0;\">\n            <script type=\"text/wxtag-template\">\n              <style>.wx-btn{height: ").concat(height, "px;opacity: 0;}</style>\n              <div class=\"wx-btn\">\u7ACB\u5373\u6253\u5F00</div>\n            </script>\n          </wx-open-launch-app>");
  }

  var hidden;
  var visibilityChange;

  function getSupportedProperty() {
    if (typeof document === 'undefined') return;

    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }
  }

  getSupportedProperty();
  /**
   * 判断页面是否隐藏（进入后台）
   */

  function isPageHidden() {
    if (typeof hidden === 'undefined') return false;
    return document[hidden];
  }
  /**
   * 通过 top.location.href 跳转
   * @param {string}} [uri] - 需要打开的地址
   */


  function evokeByLocation(uri) {
    if (typeof uri === 'undefined') {
      return;
    }

    if (window.top) {
      if (window.top.location.href.includes(uri)) {
        return;
      }

      window.top.location.href = uri;
    }
  }
  /**
   * 检测是否唤端成功
   * @param cb - 唤端失败回调函数
   * @param timeout
   */

  function checkOpen(failure, timeout) {
    var timer = setTimeout(function () {
      var pageHidden = isPageHidden();

      if (!pageHidden) {
        failure();
      }
    }, timeout);

    if (typeof visibilityChange !== 'undefined') {
      document.addEventListener(visibilityChange, function () {
        clearTimeout(timer);
      });
      window.addEventListener(visibilityChange, function () {
        clearTimeout(timer);
      });
    }

    window.addEventListener('pageshow', function () {
      clearTimeout(timer);
    }, false);
    window.addEventListener('pagehide', function () {
      clearTimeout(timer);
    }, false);
  }

  function isValidLang(lang) {
    return ['zh_CN', 'zh_HK', 'en_US', 'zh-CN', 'zh-HK', 'en-US'].includes(lang);
  }
  function getQuery(key) {
    var params = new URLSearchParams(window.location.search);
    return params.get(key);
  }
  function isPlainObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
  }
  function getSafeValue(val) {
    return JSON.stringify(isPlainObject(val) ? val : {});
  }

  var isInSpecailEnv = isBaidu || isWeibo || isWechat || isDingTalk || isQQ || isQQBrowser || isQzone;

  var CallApp = /*#__PURE__*/function () {
    // Create an instance of CallApp
    function CallApp(options) {
      _classCallCheck(this, CallApp);

      _defineProperty(this, "options", void 0);

      _defineProperty(this, "domList", []);

      _defineProperty(this, "hasApp", true);

      var defaultOptions = {
        useWxNative: true,
        timeout: 2000
      };
      this.options = _extends(defaultOptions, options);
    }
    /**
     * 注册为方法
     * generateScheme | generateIntent | generateUniversalLink | generateYingYongBao | checkOpen
     */


    _createClass(CallApp, [{
      key: "generateScheme",
      value: function generateScheme$1(config) {
        return generateScheme(config, this.options);
      }
    }, {
      key: "generateIntent",
      value: function generateIntent$1(config) {
        return generateIntent(config, this.options);
      }
    }, {
      key: "generateUniversalLink",
      value: function generateUniversalLink$1(config) {
        return generateUniversalLink(config, this.options);
      }
    }, {
      key: "generateYingYongBao",
      value: function generateYingYongBao$1(config) {
        return generateYingYongBao(config, this.options);
      }
    }, {
      key: "generateWxTag",
      value: function generateWxTag$1(config) {
        return generateWxTag(config, this.options);
      }
    }, {
      key: "checkOpen",
      value: function checkOpen$1(failure) {
        var _this$options = this.options,
            logFunc = _this$options.logFunc,
            timeout = _this$options.timeout;
        return checkOpen(function () {
          if (typeof logFunc !== 'undefined') {
            logFunc('failure');
          }

          failure();
        }, timeout);
      } // 唤端失败跳转 app store

    }, {
      key: "fallToAppStore",
      value: function fallToAppStore() {
        var _this = this;

        this.checkOpen(function () {
          evokeByLocation(_this.options.appstore);
        });
      } // 跳转到兜底页面链接

    }, {
      key: "fallToFbUrl",
      value: function fallToFbUrl(fallbackUrl) {
        this.checkOpen(function () {
          if (document.hasFocus()) {
            evokeByLocation(fallbackUrl);
          }
        });
      } // 唤端失败调用自定义回调函数

    }, {
      key: "fallToCustomCb",
      value: function fallToCustomCb(callback) {
        this.checkOpen(function () {
          callback();
        });
      } // dom事件注册

    }, {
      key: "bindClickEvent",
      value: function bindClickEvent() {
        var _this2 = this;

        this.domList.forEach(function (obj) {
          if (!obj.isRegister) {
            var config = obj.config;
            obj.btn.addEventListener('click', function () {
              if (isWechat && _this2.options.useWxNative && !obj.isWxNativeBtnReady) {
                return;
              }

              _this2.open(config);
            });
            obj.isRegister = true;
          }
        });
      }
    }, {
      key: "wxTagCalled",
      value: function wxTagCalled(reason) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'failure';
        var logFunc = this.options.logFunc;

        if (typeof logFunc !== 'undefined') {
          logFunc(type, reason);
        }
      }
    }, {
      key: "setDomConfig",
      value: function setDomConfig(config) {
        var _this3 = this;

        var _this$options2 = this.options,
            useWxNative = _this$options2.useWxNative,
            wxAppid = _this$options2.wxAppid;

        if (isWechat && useWxNative && !wxAppid) {
          throw new Error('use wx-tag need wxAppid in the options');
        }

        var list = !Array.isArray(config) ? [config] : config;
        list.forEach(function (c) {
          return _this3.registerDomClick(c);
        });
        this.bindClickEvent();

        if (!useWxNative || !window.wx) {
          return;
        }

        wx.error(function () {
          _this3.wxTagCalled({
            errMsg: 'error'
          });
        });
        document.addEventListener('WeixinOpenTagsError', function (e) {
          // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
          _this3.wxTagCalled(e.detail); // this.bindClickEvent();

        });
      }
    }, {
      key: "registerDomClick",
      value: function registerDomClick(config) {
        var _this4 = this;

        if (!config.id) {
          throw new Error('use dom you need id parameter to register');
        }

        var openapp = document.querySelector("#".concat(config.id));

        if (!openapp) {
          throw new Error("make sure the dom by #".concat(config.id, " is exists"));
        }

        var index = this.domList.findIndex(function (obj) {
          return obj.config.id === config.id;
        });

        if (index !== -1) {
          throw new Error("the #".concat(config.id, " is not only"));
        }

        var obj = {
          btn: openapp,
          config: config,
          isRegister: false,
          isWxNativeBtnReady: false
        };
        this.domList.push(obj);

        if (!this.options.useWxNative || !window.wx) {
          return;
        }

        wx.ready(function () {
          openapp.innerHTML = generateWxTag(config, _this4.options);
          var btn = openapp.firstChild;
          btn.addEventListener('ready', function () {
            obj.isWxNativeBtnReady = true;
          });
          btn.addEventListener('launch', function (e) {
            _this4.wxTagCalled(_objectSpread2({
              errMsg: 'launch'
            }, e.detail), 'pending');

            _this4.hasApp = true;
          });
          btn.addEventListener('error', function (e) {
            // 如果微信打开失败，证明没有应用，在ios需要打开app store。不能跳转universal link
            _this4.hasApp = false;

            _this4.wxTagCalled(e.detail);

            _this4.open(config);
          });
        });
      }
    }, {
      key: "getFallbackUrl",
      value: function getFallbackUrl(param) {
        var _this$options3 = this.options,
            fallback = _this$options3.fallback,
            fallbackParam = _this$options3.fallbackParam;
        var lang = getQuery('lang');

        if (lang && isValidLang(lang)) {
          lang = lang.replace('-', '_');
        }

        var queryParam = _objectSpread2(_objectSpread2(_objectSpread2({}, param), fallbackParam), {}, {
          lang: lang,
          autoOpen: -1
        });

        var fallbackUrl = "".concat(fallback).concat(generateQS(queryParam));
        return fallbackUrl;
      }
      /**
       * 唤起客户端
       * 根据不同 browser 执行不同唤端策略
       */

    }, {
      key: "open",
      value: function open(config) {
        var _this5 = this;

        var _this$options4 = this.options,
            logFunc = _this$options4.logFunc,
            huaweiStore = _this$options4.huaweiStore,
            googleStore = _this$options4.googleStore,
            universal = _this$options4.universal;
        var callback = config.callback;
        var schemeURL = this.generateScheme(config);
        var checkOpenFall;

        if (typeof logFunc !== 'undefined') {
          logFunc('pending');
        } // 除了将 config.param 透传至中转页面的 URL 之外，还需要将其他的参数传过去


        var fallbackUrl = this.getFallbackUrl(config.param);

        if (isIos || isIpad) {
          // iOS 和 iPad
          if (isInSpecailEnv) {
            evokeByLocation(fallbackUrl);
          } else if (universal) {
            // iOS9+，universalLink 唤起
            evokeByLocation(this.generateUniversalLink(config));
          } else {
            evokeByLocation(schemeURL);
            checkOpenFall = this.fallToAppStore;
          }
        } else if (isWechat && typeof this.options.yingyongbao !== 'undefined') {
          // Android ，在微信中且配置了应用宝链接
          evokeByLocation(this.generateYingYongBao(config));
        } else if (isInSpecailEnv) {
          // Android，微信等国内常见社交平台
          evokeByLocation(fallbackUrl);
        } else {
          // Android，浏览器等
          evokeByLocation(schemeURL);

          checkOpenFall = function checkOpenFall() {
            return _this5.fallToFbUrl(isHuawei ? huaweiStore : googleStore);
          };
        }

        if (typeof callback !== 'undefined') {
          this.fallToCustomCb(callback);
          return;
        }

        if (!checkOpenFall) {
          return;
        }

        checkOpenFall.call(this);
      }
    }]);

    return CallApp;
  }();

  function openMyApp(params) {
    var supportUniversal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _params$fallback = params.fallback,
        fallback = _params$fallback === void 0 ?  'https://m.global.mplusonline.com/openapp'  : _params$fallback,
        redirectType = params.redirectType,
        redirectValue = params.redirectValue;
    var option = {
      scheme: {
        protocol: 'tickrsmy',
        path: 'jump'
      },
      appstore: 'https://apps.apple.com/us/app/m-global-winning-the-world/id6446663488',
      huaweiStore: 'https://appgallery.huawei.com/app/C107923643',
      googleStore: 'https://play.google.com/store/apps/details?id=com.mplusglobal.app',
      fallback: fallback,
      fallbackParam: params.fallbackParam,
      timeout: 5000
    };

    if (supportUniversal) {
      _extends(option, {
        universal: {
          host:  'global.mplusonline.com' ,
          path: '/app-deep-link/route'
        }
      });
    }

    var lib = new CallApp(option);
    lib.open({
      path: '',
      param: {
        redirectType: redirectType,
        redirectValue: getSafeValue(redirectValue),
        lang: getQuery('lang'),
        autoOpen: getQuery('autoOpen')
      }
    });
  }
  function openSgApp(params) {
    // eslint-disable-next-line no-console
    console.log('todo', params);
  }
  var isInSpecailEnv$1 = isInSpecailEnv;
  var tools = {
    openMyApp: openMyApp,
    openSgApp: openSgApp,
    isInSpecailEnv: isInSpecailEnv$1
  };

  exports.default = tools;
  exports.isInSpecailEnv = isInSpecailEnv$1;
  exports.openMyApp = openMyApp;
  exports.openSgApp = openSgApp;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
